import __request__ from 'routing/request';
interface DefenderCreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly name: string;
    readonly defender_client_secret: string;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
    readonly defender_tenant_id: string;
    readonly defender_client_id: string;
}
interface DefenderRequestImpl {
    readonly defender_client_secret: string;
    readonly defender_tenant_id: string;
    readonly defender_client_id: string;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: DefenderRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.microsoftdefender.api.DefenderResource/microsoftdefender/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Microsoft Defender input
 */
export function create(JSONbody: DefenderCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.microsoftdefender.api.DefenderResource/microsoftdefender/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
